import { Expose } from 'class-transformer';
import { IsOptional } from 'class-validator';

export class RefreshTokenResponseDto {
    @Expose()
    @IsOptional()
    accessToken: string;

    @Expose()
    @IsOptional()
    refreshToken?: string;
}
